// Systemowy przycisk/gest „wstecz" zamyka otwarty overlay (Quick View, koszyk, menu mobilne,
// wyszukiwarka, filtry) zamiast opuszczać stronę. Podpina się wyłącznie do publicznego API
// ModalComponent z theme.js (zdarzenie `toggle` + metoda hide()), więc nie wymaga zmian w plikach
// motywu i przetrwa jego aktualizację.
// Loaded by layout/theme.liquid — overlaye (menu, koszyk) są na każdej stronie.
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  // overlaye, dla których wypchnęliśmy sztuczny wpis w historii, w kolejności otwierania
  const stack = [];
  // liczba wywołanych przez nas history.back(), których popstate mamy zignorować
  let selfBack = 0;
  // zamknięcie wywołane przez „wstecz" — wpis w historii jest już zdjęty przez przeglądarkę
  let popping = false;
  let navigating = false;

  // `toggle` wysyła też <details> (akordeony) — odsiewamy je po API ModalComponent.
  // Sprawdzenie .fixed-overlay łapie też <quick-view-modal> tworzone dynamicznie przez
  // lp-inline-product-recs-v2.js.
  const isOverlay = (el) =>
    el instanceof HTMLElement &&
    typeof el.hide === 'function' &&
    typeof el.show === 'function' &&
    el.querySelector('.fixed-overlay') !== null;

  const onOverlayLinkClick = (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    if (link.getAttribute('href').charAt(0) === '#') return;
    if (link.protocol !== 'http:' && link.protocol !== 'https:') return;
    if (!stack.some((overlay) => overlay.contains(link))) return;

    // location.replace() nadpisuje nasz sztuczny wpis docelowym adresem, więc jedno „wstecz"
    // wraca na poprzednią stronę. Bez tego każde przejście z menu mobilnego wymagałoby dwóch.
    event.preventDefault();
    navigating = true;
    stack.length = 0;
    window.location.replace(link.href);
  };

  // handler kliknięć wisi na dokumencie tylko na czas otwartego overlaya;
  // addEventListener z tą samą referencją jest idempotentne, więc można wołać wielokrotnie
  const syncLinkListener = () => {
    if (stack.length) {
      document.addEventListener('click', onOverlayLinkClick);
    } else {
      document.removeEventListener('click', onOverlayLinkClick);
    }
  };

  // capture, bo `toggle` z <details> nie bąbelkuje
  document.addEventListener(
    'toggle',
    (event) => {
      const el = event.target;
      if (!isOverlay(el)) return;

      if (el.hasAttribute('open')) {
        if (stack.indexOf(el) !== -1) return;
        stack.push(el);
        history.pushState({ lpOverlay: stack.length }, '');
        syncLinkListener();
        return;
      }

      const index = stack.indexOf(el);
      if (index === -1) return;
      stack.splice(index, 1);
      syncLinkListener();

      // przy `popping` przeglądarka zdjęła już nasz wpis, przy `navigating` nadpisze go
      // location.replace() — dodatkowe history.back() cofnęłoby o prawdziwą stronę
      if (popping || navigating) return;
      selfBack += 1;
      history.back();
    },
    true
  );

  window.addEventListener('popstate', () => {
    if (selfBack > 0) {
      selfBack -= 1;
      return;
    }

    // odrzuć overlaye usunięte z DOM (np. quick view podmieniony przez predictive search)
    while (stack.length && !stack[stack.length - 1].isConnected) stack.pop();

    const overlay = stack[stack.length - 1];
    if (overlay) {
      // hide() zdejmuje atrybut `open` synchronicznie, więc handler `toggle` zdąży zobaczyć flagę
      popping = true;
      overlay.hide();
      popping = false;
    }
    syncLinkListener();
  });
})();
